/* eslint-disable react/destructuring-assignment */
import { ErrorMessage } from 'formik';
import React, { Component } from 'react';
import Input from '../../../components/Input/input.component';
import {
	CNPJMask, CEPMask, phoneMask,
} from '../../../components/Input/Masks';
import WidgetModalForm, { ModalFormContext } from '../../../components/Modal/modalForm.component';
import Required from '../../../components/Required/required.component';
import SelectMulti from '../../../components/SelectMulti/selectmulti.component';
import MunicipioService from '../../../services/municipioService';
import { EditarEntidadeValidationSchema } from './editEntidade.modal.validate';

export default class EditarModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			entidade: {
				...this.props.entidade,
			},
			municipios: [],
			municipioSelecionado: {
				...this.props.entidade.endereco.municipio,
			},
		};
	}

	async componentDidMount() {
		const allMunicipios = await MunicipioService.findAll();
		this.setState({
			municipios: [...allMunicipios.data],
		});
	}

	onChangeMunicipio(item) {
		const newState = this.state;
		newState.municipioSelecionado = item.object;
		newState.entidade.endereco.municipio = item.object;
		this.setState(newState);
	}

	render() {
		const {
			props: {
				isOpenEditar,
				handleCloseEditar,
				handleSubmitEditar,
			},
			state: {
				entidade,
				municipios,
				municipioSelecionado,
			},
		} = this;

		return (
			<WidgetModalForm
				textCancelar='Cancelar'
				textConfirmar='Salvar'
				validationSchema={EditarEntidadeValidationSchema}
				initialValues={entidade}
				title='Editar entidade'
				confirmar={(values) => {
					const dados = values;
					dados.telefonePrincipal = values.telefonePrincipal.replace(
						/\D/g,
						'',
					);
					dados.telefoneSecundario = values.telefoneSecundario.replace(
						/\D/g,
						'',
					);
					handleSubmitEditar(dados);
				}}
				isOpen={isOpenEditar}
				cancelar={handleCloseEditar}
				modalConfirmarFechar
				modalConfirmarCancelar
				modalConfirmarCancelarTitulo='Atenção!'
				modalConfirmarCancelarCorpo='Tem certeza que deseja cancelar? Todos os dados preenchidos serão perdidos.'
				iconCancelar='fas fa-times'
				iconConfirmar='fas fa-save'
				tamanho='lg'
			>
				<ModalFormContext.Consumer>
					{({
						handleChange, values, setFieldValue,
					}) => (
						<div>
							<div className='row'>
								<div className='col-md-12 form-group'>
									<label>
										CNPJ:
										{' '}
										<Required />
									</label>
									<Input
										placeholder='00.000.000/0000-00'
										name='cnpj'
										type='text'
										mask={CNPJMask}
										onChange={handleChange}
										value={values.cnpj}
										disabled
									/>
									<ErrorMessage
										name='cnpj'
										render={msg => (
											<span className='text-danger'>
												{msg}
											</span>
										)}
									/>
								</div>{/* .col-md-12 .form-group */}
							</div>{/* .row */}
							<div className='row'>
								<div className='col-md-12 form-group'>
									<label>
										Entidade:
										{' '}
										<Required />
									</label>
									<Input
										type='input'
										name='nome'
										onChange={handleChange}
										value={values.nome}
										maxLength='255'
									/>
									<ErrorMessage
										name='nome'
										render={msg => (
											<span className='text-danger'>
												{msg}
											</span>
										)}
									/>
								</div>{/* .col-md-12 .form-group */}
							</div>{/* .row */}
							<div className='row'>
								<div className='col-md-12 form-group'>
									<label>
										E-mail:
										{' '}
										<Required />
									</label>
									<Input
										type='input'
										name='email'
										onChange={handleChange}
										value={values.email}
										maxLength='255'
									/>
									<ErrorMessage
										name='email'
										render={msg => (
											<span className='text-danger'>
												{msg}
											</span>
										)}
									/>
								</div>{/* .col-md-12 .form-group */}
							</div>{/* .row */}
							<div className='row'>
								<div className='col-md-6 form-group'>
									<label>
										Telefone principal:
										{' '}
										<Required />
									</label>
									<Input
										placeholder='(00) 0 0000-0000'
										type='input'
										mask={phoneMask}
										name='telefonePrincipal'
										onChange={(value) => {
											const result = value.target.value.replace(
												/\D/g,
												'',
											);
											setFieldValue(
												'telefonePrincipal',
												result,
											);
										}}
										onBlur={(value) => {
											const result = value.target.value.replace(
												/\D/g,
												'',
											);
											setFieldValue(
												'telefonePrincipal',
												result,
											);
										}}

										value={values.telefonePrincipal}
									/>
									<ErrorMessage
										name='telefonePrincipal'
										render={msg => (
											<span className='text-danger'>
												{msg}
											</span>
										)}
									/>
								</div>{/* .col-md-6 .form-group */}
								<div className='col-md-6 form-group'>
									<label>
										Telefone secundário:
									</label>
									<Input
										placeholder='(00) 0 0000-0000'
										type='input'
										mask={phoneMask}
										name='telefoneSecundario'
										onChange={(value) => {
											const result = value.target.value.replace(
												/\D/g,
												'',
											);
											setFieldValue(
												'telefoneSecundario',
												result,
											);
										}}
										onBlur={(value) => {
											const result = value.target.value.replace(
												/\D/g,
												'',
											);
											setFieldValue(
												'telefoneSecundario',
												result,
											);
										}}
										value={values.telefoneSecundario}
									/>
									<ErrorMessage
										name='telefoneSecundario'
										render={msg => (
											<span className='text-danger'>
												{msg}
											</span>
										)}
									/>
								</div>{/* .col-md-6 .form-group */}
							</div>{/* .row */}
							<div className='row'>
								<div className='col-md-12'>
									<label>
										Município:
										{' '}
										<Required />
									</label>
									<div className='form-group'>
										<SelectMulti
											isClearable={false}
											isMulti={false}
											name='endereco.municipio.codigoIbge'
											uniqueKey='codigoIbge'
											label='nome'
											value={
												municipioSelecionado
											}
											onChange={(item) => {
												this.onChangeMunicipio(item);
											}}
											options={municipios}
										/>
										<ErrorMessage
											name='endereco.municipio.codigoIbge'
											render={msg => (
												<span className='text-danger'>
													{msg}
												</span>
											)}
										/>
									</div>{/* .form-group */}
								</div>{/* .col-md-12 */}
							</div>{/* .row */}
							<div className='row'>
								<div className='col-md-6 form-group'>
									<label>
										CEP:
										{' '}
										<Required />
									</label>
									<Input
										placeholder='00.000-000'
										type='input'
										mask={CEPMask}
										name='endereco.cep'
										onChange={handleChange}
										onBlur={handleChange}
										value={values.endereco.cep}
									/>
									<ErrorMessage
										name='endereco.cep'
										render={msg => (
											<span className='text-danger'>
												{msg}
											</span>
										)}
									/>
								</div>{/* .col-md-6 form-group */}
								<div className='col-md-6 form-group'>
									<label>
										Bairro:
										{' '}
										<Required />
									</label>
									<Input
										type='input'
										name='endereco.bairro'
										onChange={handleChange}
										value={values.endereco.bairro}
										maxLength='255'
									/>
									<ErrorMessage
										name='endereco.bairro'
										render={msg => (
											<span className='text-danger'>
												{msg}
											</span>
										)}
									/>
								</div>{/* .col-md-6 form-group */}
							</div>{/* .row */}
							<div className='row'>
								<div className='col-md-12 form-group'>
									<label>
										Logradouro:
										{' '}
										<Required />
									</label>
									<Input
										type='input'
										name='endereco.logradouro'
										onChange={handleChange}
										value={values.endereco.logradouro}
										maxLength='255'
									/>
									<ErrorMessage
										name='endereco.logradouro'
										render={msg => (
											<span className='text-danger'>
												{msg}
											</span>
										)}
									/>
								</div>{/* .col-md-12 form-group */}
							</div>{/* .row */}
							<div className='row'>
								<div className='col-md-6 form-group'>
									<label>
										Número:
										{' '}
										<Required />
									</label>
									<Input
										type='input'
										name='endereco.numero'
										onChange={handleChange}
										value={values.endereco.numero}
										maxLength='255'
									/>
									<ErrorMessage
										name='endereco.numero'
										render={msg => (
											<span className='text-danger'>
												{msg}
											</span>
										)}
									/>
								</div>{/* .col-md-6 form-group */}
								<div className='col-md-6 form-group'>
									<label>Complemento:</label>
									<Input
										type='input'
										name='endereco.complemento'
										onChange={handleChange}
										value={values.endereco.complemento}
										maxLength='255'
									/>
									<ErrorMessage
										name='endereco.complemento'
										render={msg => (
											<span className='text-danger'>
												{msg}
											</span>
										)}
									/>
								</div>{/* .col-md-6 form-group */}
							</div>{/* .row */}
						</div>
					)}
				</ModalFormContext.Consumer>
			</WidgetModalForm>
		);
	}
}
